import {
  Common_DeviceDto,
  GetDevices_GetDevicesResponse,
} from "../../../api";

export enum ExternalDeviceType {
  DimmerD = "DimmerD",
  DimmerS = "DimmerS",
  ClockMechanicE = "ClockMechanicE",
  ClockMechanicN = "ClockMechanicN",
  ClockMechanicV = "ClockMechanicV",
  ElectronicClock = "ElectronicClock",
  LedPanel = "LedPanel",
  UpsI = "UpsI",
  SensorBlockT = "SensorBlockT",
}

export enum ExternalDeviceStatus {
  Added = 'Added',
  New = 'New'
}

export type ExternalDeviceItem = {
  text: string;
  address: number | string;
  type: ExternalDeviceType | string | number;
  id: string;
  isConnected: boolean;
  isVisible: boolean;
};

export type ExternalDeviceSourceItem = Common_DeviceDto;

export type ExternalDevicesResult = GetDevices_GetDevicesResponse;

export type ExecuteCommandResult = {
  Params?: number[];
  [key: string]: unknown;
};

export type ExecuteCommand = (
  target: unknown,
  command: unknown,
  params: unknown[]
) => Promise<ExecuteCommandResult>;

export type ExecuteDeviceCommand = (
  devAdr: number | string,
  devType: number | string,
  command: unknown,
  parameters: unknown[]
) => Promise<unknown>;

export type ExternalDevicesProps = {
  executeCommand: ExecuteCommand;
  executeDeviceCommand?: ExecuteDeviceCommand;
  clockStationId?: string | number;
  selectedDeviceId?: string | number | null;
  deviceId?: string;
  isAdmin?: boolean;
};
